<qai-alert class="theme-light" kind="hint" [title]="('call.HINT_LABEL' | transloco)" [maxHeight]="maxHeight">
  {{ hint }}
</qai-alert>
